import "../assets/About.css";

export default function About() {
  return (
    <div className="about-main-container">
      <section className="about-content">
        <h1 className="about-heading">About Me</h1>
        <div className="about-divider" />

        <div className="about-copy">
          <p>
            I’m Otis Guess, a software engineer and founder of Best Guess
            Digital. I build practical web and mobile apps for businesses,
            organizations, and community-driven projects. My background in
            customer service, mentoring, and hands-on problem solving helps me
            understand what people actually need from the software they use.
          </p>

          <p>
            I care about building clean, useful systems that make work easier.
            Whether I’m creating a business app, store, event tool, or portfolio
            site, my goal is to bring structure, clarity, and reliability to the
            project from start to finish.
          </p>
        </div>
      </section>
    </div>
  );
}
